import useStyles from "isomorphic-style-loader/useStyles";
import React, { useMemo } from "react";
import classes from './style.module.scss'
import SizeChartMain from './components/main'
import { SET_SIZE_CHART } from "../../../../store/actions/global";
import ReactDOM from 'react-dom'
import RightToLeft from '../../../components/transitions/right-to-left'
import useOpenSizeChart from "../../../hooks/open-sizechart"
import { useSizeChartNew } from "../../../hooks/sizechartnew";
import SizeChartHead from "./components/main/size-chart-head";
import Cookies from "js-cookie";
import { useApp } from "../../../hooks/common";
import { useHistory } from "react-router-dom";


const SizeChartInit = props => {
    const {sizechartData, setSizeChart} = props || {}
    const { data, show} = sizechartData || {}
    const { products, taglia, productSizeData, countryCode, selectedProduct} = data || {}

    const countryCodeCache = useMemo(() => {
        return countryCode || Cookies.get("sizeDefaultCountry")
    }, [countryCode, Cookies.get("sizeDefaultCountry")])

    // 产品类别 1鞋子 2衣服 3bra
    const formateSizeData = useSizeChartNew(productSizeData, taglia, '', products, countryCodeCache, selectedProduct)

    return formateSizeData?.hasSizeChartData ?
           <SizeChartMain
                {...props}
                show={show}
                formateSizeData={formateSizeData}
                productTaglia={taglia}
                productType={formateSizeData?.productType}
                countryCode={countryCodeCache}
                /> :
           <React.Fragment></React.Fragment>
}

const Wrapped = props => {
    useStyles(classes)

    const isApp = useApp()
    const { sizeChart, setSizeChart } = useOpenSizeChart()
    const history = useHistory()

    const closeSizeChart = () => {
        setSizeChart({
            type: SET_SIZE_CHART,
            payload: {
                show: false,
                data: null
            }
        })
    }

    return <React.Fragment>
        <RightToLeft in={sizeChart?.show} className={classes.SizeChartContainer}>
            <div>
                <SizeChartHead closeSizeChart={closeSizeChart} history={history}/>
                <div className={`${isApp ? classes.BdApp: classes.Bd}`}>
                    <SizeChartInit {...props} show={sizeChart?.show} sizechartData={sizeChart} closeSizeChart={closeSizeChart}/>
                </div>
            </div>
        </RightToLeft>
        {/* {props?.show && <BlackMask onClick={closeSizeChart}/>} */}
    </React.Fragment>
}


const SizeChartWrapped = props => {
    if (typeof window === 'undefined') {
        return null
    }
    return ReactDOM.createPortal(
        <Wrapped {...props}/>,
        document.getElementById('root')
    )
}

export default SizeChartWrapped

/**
 * 网站弹出式sizechart
   接受product，taglia, countryCode(仅app)数据
   // 处理数据
    * 使用示例
   const dispatch = useDispatch()
   dispatch({
       type: SET_SIZE_CHART,
       payload:{
           show: true,
           data: {
               products, // 需要传入products 可以从useProduct抛出的productVO种获取
               taglia, // 产品detail最外层
               productSizeData, // 产品detail最外层
               countryCode
           }
       }
   })
*/